import React, { useState } from 'react'

import _ from 'lodash'
import { Filtro } from '../../utils/Filtro'
import { routes } from '../../constants'
import apiService from '../../services/api.service'
import { Column } from 'primereact/column'
import '../../index.scss'
import LtsLookup from './lts-lookup'
import { InputText } from 'primereact/inputtext'
import './lts-lookup-endereco.scss'

export default function LtsLookupEndereco(props) {
  const [filters, setFilters] = useState([])

  const columns = [
    {
      field: 'oid',
      header: 'Id',
      columnKey: 'oid',
      sortable: false,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    {
      field: 'descricao',
      header: 'Descrição',
      columnKey: 'descricao',
      columnSortField: 'descricao',
      sortable: true,
      filter: true,
      visible: true,
    },
    {
      field: 'endereco',
      header: 'Endereço',
      columnKey: 'endereco',
      columnSortField: 'endereco',
      sortable: true,
      filter: true,
      visible: true,
    },
    {
      field: 'numero',
      header: 'Número',
      columnKey: 'numero',
      columnSortField: 'numero',
      sortable: true,
      filter: true,
      visible: true,
    },
  ]

  const loadDataFn = (params) => {
    return apiService.post(`/lottustech/enderecos/all`, params)
  }

  const onKeyPress = (e) => {
    const value = _.get(props, 'value', null)
    if (value) {
      const descricao = _.get(value, 'descricao', null)
      const filters = [new Filtro('descricao', descricao, 'CONTEM')]
      setFilters(filters)
    }
  }

  const onComplete = (event) => {
    const value = event.query
    if (value) {
      const filters = [new Filtro('descricao', value, 'CONTEM')]
      setFilters(filters)
    }
  }

  const pathOnEditFn = () => {
    const oid = _.get(props, 'oidRecord', null)
    if (oid) {
      return `${routes.PATH_ENDERECO}/${oid}`
    } else {
      return `${routes.PATH_ENDERECO}/novo`
    }
  }

  const onInputFilter = (e) => {
    const value = e.value
    if (typeof value === 'string') {
      props.onChange({
        oid: '',
        descricao: value,
      })
    } else {
      props.onChange(value)
    }
  }

  const autoCompleteTemplate = (data) => {
    return `${data.oid} - ${data.descricao}`
  }

  const onResolvingColumn = () => {
    return columns.map((col) => {
      // Remove props that should not be spread to DOM elements
      const { showFilterMenuOptions, showClearButton, showFilterMenu, ...columnProps } = col

      if (col.field === 'oid') {
        return (
          <Column
            {...columnProps}
            key={col.field}
            bodyClassName="column-codigo-body-width"
            filterHeaderClassName="column-codigo-filter-header-width"
            headerClassName="column-codigo-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }
      if (col.field === 'descricao') {
        return (
          <Column
            {...columnProps}
            key={col.field}
            bodyClassName="column-descricao-body-width"
            filterHeaderClassName="column-descricao-filter-header-width"
            headerClassName="column-descricao-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }
      if (col.field === 'endereco') {
        return (
          <Column
            {...columnProps}
            key={col.field}
            bodyClassName="column-descricao-body-width"
            filterHeaderClassName="column-descricao-filter-header-width"
            headerClassName="column-descricao-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }
      if (col.field === 'numero') {
        return (
          <Column
            {...columnProps}
            key={col.field}
            bodyClassName="column-codigo-body-width"
            filterHeaderClassName="column-codigo-filter-header-width"
            headerClassName="column-codigo-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }

      return null
    })
  }

  const columnFilterElement = (column) => {
    return <InputText style={{ width: '100%' }} name={column.field} onChange={(e) => onChangeTableFilter(column, e)} />
  }

  const onChangeTableFilter = (column, e) => {
    const campo = column.field

    //remove o filtro do campo atual com valor 'antigo'
    const newFilters = filters.filter((f) => f.campo !== campo)

    const valor = _.get(e, 'target.value', null)
    if (valor) {
      const tipoFiltro = campo === 'oid' ? 'IGUAL_A' : 'CONTEM'
      newFilters.push({ campo, valor, tipoFiltro })
    }

    setFilters(newFilters)
  }

  const resolveFilters = (filters) => {
    return filters
  }

  const resolveValue = (data) => {
    const value = _.get(props, 'value', null)
    const descricao = _.get(value, 'descricao', null)
    return descricao
  }

  return (
    <React.Fragment>
      <LtsLookup
        label={props.label}
        value={resolveValue()}
        name={props.name}
        field={props.field}
        history={props.history}
        autoCompleteTemplate={autoCompleteTemplate}
        onKeyPress={onKeyPress}
        onComplete={onComplete}
        onInputFilter={onInputFilter}
        pathOnEditFn={pathOnEditFn}
        header={props.label}
        columns={columns}
        onResolvingColumn={onResolvingColumn}
        loadDataFn={loadDataFn}
        resolveFilters={resolveFilters}
        onChange={props.onChange}
        filters={filters}
        setFilters={setFilters}
        editDisabled={props.editDisabled}
        editHidden={props.editHidden}
      />
    </React.Fragment>
  )
}
